import { createPortal } from 'react-dom';
import PluginFrame from '../utils/PluginFrame';
import { usePluginConfig } from '../contexts/pluginContext';

const Head = ({ children }) => {
  const frameConfig = usePluginConfig().frameConfig;
  const pluginFrame = new PluginFrame(frameConfig);
  return createPortal(children, pluginFrame.shadowRoot);
};
export default Head;
